type Props = {
  /** Texto accesible y tooltip */
  title: string;
  /** Tamaño visual del icono en px */
  size?: number;
  className?: string;
  /** Si se pasa, se renderiza como botón (p. ej. activar filtro) */
  onClick?: () => void;
  /** Filtro “solo modo humano” activo */
  active?: boolean;
};

export function HumanAttentionBellIcon({ title, size = 18, className, onClick, active }: Props) {
  const cls = [
    'va-bell-attention',
    active ? 'va-bell-attention--active' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  const svg = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#d97706"
      strokeWidth={2}
      aria-hidden
    >
      <path d="M12 22a2 2 0 0 0 2-2H10a2 2 0 0 0 2 2z" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={cls}
        title={title}
        aria-label={title}
        aria-pressed={active}
        onClick={onClick}
        style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
      >
        {svg}
      </button>
    );
  }

  return (
    <span
      className={cls}
      title={title}
      role="img"
      aria-label={title}
      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
    >
      {svg}
    </span>
  );
}
